import {
  cn,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@playerbase/ui';
import type { StageColour } from '@playerbase/types';
import { STAGE_COLOUR_ORDER } from '@playerbase/types';

import {
  STAGE_COLOUR_LABELS,
  STAGE_SWATCH_CLASSES,
} from '../../../games/stage-colour-classes.js';

type ColourPalettePopoverProps = {
  value: StageColour;
  onChange: (next: StageColour) => void;
  disabled?: boolean;
};

export function ColourPalettePopover({
  value,
  onChange,
  disabled,
}: ColourPalettePopoverProps): JSX.Element {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          aria-label={`Stage colour: ${STAGE_COLOUR_LABELS[value]}`}
          className={cn(
            'h-5 w-5 rounded-sm border transition-opacity',
            STAGE_SWATCH_CLASSES[value],
            disabled ? 'opacity-50' : 'hover:opacity-90',
          )}
        />
      </PopoverTrigger>
      <PopoverContent className="w-auto p-2" align="start">
        <div className="grid grid-cols-4 gap-1.5">
          {STAGE_COLOUR_ORDER.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => onChange(c)}
              aria-label={STAGE_COLOUR_LABELS[c]}
              className={cn(
                'h-6 w-6 rounded-sm border',
                STAGE_SWATCH_CLASSES[c],
                value === c && 'ring-1 ring-accent ring-offset-1 ring-offset-surface',
              )}
            />
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
